import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { deleteLearningPath } from "../../../api/endpoints/LearningPathEndpoints";

export default function useDeleteLearningPath() {
  return useMutation<void, AxiosError, { learningPathId: string }>({
    mutationKey: ["delete-learning-path"],
    mutationFn: ({ learningPathId }) => deleteLearningPath(learningPathId),
  });
}
